import {Elements} from '@stripe/react-stripe-js';
import StripeForm from './StripeForm';

const StripeCheckout=({stripePromise, clientSecret})=>{
    const options = {
        clientSecret: clientSecret,
        paymentMethodCreation: 'manual',
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <StripeForm />
        </Elements>
    );
};

export default StripeCheckout;
